/* FLA Mega Menu — toggles the independent shop bar (.fla-shopbar) on CLICK, with a smooth
   open/close animation.

   The parent nav item is rendered by header-mega-menu as a button[data-fla-mega-toggle="<handle>"]
   that shows/hides the matching <nav class="fla-shopbar" data-mega-for="<handle>">. When a "Mega
   menu item" block has "Auto-open on its category page" enabled AND the visitor is on that parent's
   page, header-mega-bar renders the bar already open (class .is-open, no [hidden]) and the toggle is
   a button so the visitor can still close/re-open it. On other pages the parent is a plain link.

   Opening adds .is-open (CSS fades/slides it in); closing removes it so it animates out, then the bar
   is hidden once the transition ends. Per-category dropdowns inside the bar are pure CSS. */
(function () {
  var OUT_MS = 260; // must be >= the .fla-shopbar transition duration

  function bars() { return Array.prototype.slice.call(document.querySelectorAll('.fla-shopbar')); }
  function barFor(handle) { return document.querySelector('.fla-shopbar[data-mega-for="' + handle + '"]'); }
  function toggleFor(handle) { return document.querySelector('[data-fla-mega-toggle="' + handle + '"]'); }
  function isOpen(bar) { return !bar.hidden && bar.classList.contains('is-open'); }

  function setAria(handle, open) {
    var t = toggleFor(handle);
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function openBar(bar) {
    clearTimeout(bar._flaCloseTimer);
    bar.hidden = false;
    requestAnimationFrame(function () { bar.classList.add('is-open'); });
    setAria(bar.getAttribute('data-mega-for'), true);
  }

  function closeBar(bar) {
    // Permanently-open bars (single Mega block + "keep open on inner pages") never close.
    if (bar.hasAttribute('data-fla-permanent')) return;
    setAria(bar.getAttribute('data-mega-for'), false);
    if (bar.hidden) return;
    bar.classList.remove('is-open');
    var finish = function () { if (!bar.classList.contains('is-open')) bar.hidden = true; };
    var onEnd = function (e) {
      if (e.target === bar && e.propertyName === 'opacity') {
        bar.removeEventListener('transitionend', onEnd);
        finish();
      }
    };
    bar.addEventListener('transitionend', onEnd);
    bar._flaCloseTimer = setTimeout(finish, OUT_MS + 40);
  }

  function closeAllExcept(except) {
    bars().forEach(function (b) { if (b !== except) closeBar(b); });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fla-mega-toggle]').forEach(function (toggle) {
      if (toggle.dataset.flaMegaBound) return;
      toggle.dataset.flaMegaBound = '1';

      var handle = toggle.getAttribute('data-fla-mega-toggle');
      var bar = barFor(handle);
      if (!bar) return;

      // Sync the toggle with any server-rendered (auto-open) state.
      setAria(handle, isOpen(bar));

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (isOpen(bar)) {
          closeBar(bar);
        } else {
          closeAllExcept(bar);
          openBar(bar);
        }
      });
    });
  }

  // Close when clicking outside any bar or toggle.
  document.addEventListener('click', function (e) {
    if (e.target.closest && (e.target.closest('.fla-shopbar') || e.target.closest('[data-fla-mega-toggle]'))) return;
    closeAllExcept(null);
  });
  // Close on Escape.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAllExcept(null);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Re-bind after a section reload in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
